import { Flipper, Flipped, ExitWrapper } from "./Flipper";
import { CBLAnimationNGProvider } from "./CBLAnimationNGContext";
export * from "./chat-box-list-animation-engine";
export * from "./CBLAnimationNGContext";

const zCBLAnimationModule = {
	Component: {
		CBLAnimationNGProvider,
		Flipper,
		Flipped,
		ExitWrapper,
	},
};

export default zCBLAnimationModule;
